<div class="fs-2 with-close" mat-dialog-title>
    Édition
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <div class="card-text row">
        <div class="col-6">
            <mat-form-field>
                <mat-label>Chambres</mat-label>
                <input type="number" step="1" matInput [(ngModel)]="favorite.bedrooms">
            </mat-form-field>
        </div>
        <div class="col-6">
            <mat-form-field>
                <mat-label>Toilette</mat-label>
                <input type="number" step="1" matInput [(ngModel)]="favorite.restrooms">
            </mat-form-field>
        </div>
        <div class="col-6">
            <mat-form-field>
                <mat-label>Salle de bain</mat-label>
                <input type="number" step="1" matInput [(ngModel)]="favorite.bathrooms">
            </mat-form-field>
        </div>
        <div class="col-6">
            <mat-form-field>
                <mat-label>Salle d'eau</mat-label>
                <input type="number" step="1" matInput [(ngModel)]="favorite.shower_rooms">
            </mat-form-field>
        </div>
        <div class="col-6">
            <mat-form-field>
                <mat-label>Parking / Garage</mat-label>
                <input type="number" step="1" matInput [(ngModel)]="favorite.parking">
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Piscine</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.pool">
                    <mat-option [value]="false">Non</mat-option>
                    <mat-option [value]="true">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Cave</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.cellar">
                    <mat-option [value]="false">Non</mat-option>
                    <mat-option [value]="true">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Balcon / Terrasse</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.outside">
                    <mat-option [value]="false">Non</mat-option>
                    <mat-option [value]="true">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()"  class="btn btn-outline">
        Annuler
    </button>
    <button type="button" (click)="onYesClick()"  class="btn btn-primary">
        Valider
    </button>
</div>


